// extracted by mini-css-extract-plugin
module.exports = {"root":"modelVersions_root__oXJNV","ul":"modelVersions_ul__0K0CH"};